import React from "react";
import SearchMenu from "../components/SearchMenu";
import MenuBar from "../components/MenuBar";
import Footer from "../components/Footer";

function GrievanceRedressal() {
  return (
    <>
      <SearchMenu />
      <MenuBar />
      <div class="container-wrapper py-12">
        <div>
          <h1 className=" text-2xl font-bold pb-2">Grievance Redressal</h1>
        </div>
        <p>
          This policy on Grievance Redressal is set out as a mechanism available
          within the organization to enable the customers &amp; Business
          Associates of the company to lodge their complaints / grievances to
          company in relation to their dealings with company, if any, being
          considered for them and for addressing the same in a time bound
          manner, by following the provisions as provided herein (the Grievance
          Redressal Mechanism).
          <br />
          <br />
          This policy document aims at minimizing instances of customer /
          Business Associate complaints and grievances through proper service
          delivery and review mechanism and also to ensure prompt Redressal of
          complaints and grievances, if there are any.
        </p>

        <h5>MECHANISM OF COMPLAINTS</h5>
        <p>
          Customer can lodge his / her grievance through any of the following
          channels:
        </p>

        <ul style={{ paddingLeft: "0px" }}>
          <li>
            <i class="fa fa-hand-o-right"></i> Complaint in Person: A customer
            can lodge a complaint in person during working hours at Customer
            Service Department (CSD) of company, established in its corporate
            office, by submitting a written letter and giving full details, to
            CSD and obtain an acknowledgement for the same.
          </li>
          <br />
          <li>
            <i class="fa fa-hand-o-right"></i> Complaints through post / email:
            Customers can also submit their grievances by post at the following
            address or through email at directors@unifywellness.com by giving
            full disclosures and details of the complainant and giving specific
            instances of the cause of complaint.{" "}
          </li>
        </ul>

        <h5>The Customer Service Department</h5>
        <ul>
          <li style={{ lineHeight: "2" }}>
            <i class="fa fa-hand-o-right"></i>
            {/* Company Address -55,2nd floor, Lane 2 , westend marg ,saidullajab, near saket
          metro station,new delhi ,110030 */}
            <br />
            <p>Ph-+91 8851924626 <br /> Mail ID - director@unifywellness.co.in </p>
          </li>

          <li style={{ lineHeight: "2" }}>
            <i class="fa fa-hand-o-right"></i>
            The telephone numbers, complete address and email address etc. will
            be prominently displayed on the unify Wellness Pvt. Ltd. website
            www.unifywellness.com for ease of contact by the customers.
          </li>

          <li style={{ lineHeight: "2" }}>
            <i class="fa fa-hand-o-right"></i>
            Grievances lodged through the web site of the company. Company has
            introduced a web based mechanism, for lodging Complaints /
            Grievances by customers. This is known as Grievance portal
            (www.unifywellness.co.in ) Customers may make use of the said Portal
            to communicate their grievances.
          </li>
        </ul>

        <h5>RESOLUTION OF COMPLAINTS / GRIEVANCES</h5>
        <ul style={{ paddingLeft: "0px" }}>
          <li style={{ lineHeight: "2" }}>
            <i class="fa fa-hand-o-right"></i>
            Any complaint through e-mail / letters / in - person shall be
            acknowledged promptly after receipt, at the company corporate
            office.
          </li>

          <li style={{ lineHeight: "2" }}>
            <i class="fa fa-hand-o-right"></i>
            The Complaints will be registered in the Customer Grievance Register
            (CGR) maintained electronically and / or physically, and shall
            include full details of the complainant (name, address and contact
            details), date of receipt, fact of the complaint, category of
            complaint etc.
          </li>

          <li style={{ lineHeight: "2" }}>
            <i class="fa fa-hand-o-right"></i>
            The Grievance Redressal Committee (GRC) of company will take steps
            to redress the grievances with care and diligence, normally within
            the period of 30 working days from the date of receipt of the
            complaints.
          </li>

          <li style={{ lineHeight: "2" }}>
            <i class="fa fa-hand-o-right"></i>
            If the complainant is not satisfied with the reply / action /
            resolution given by Grievance Redressal Committee (GRC), he / she
            may directly approach the Nodal Officer of the Company for further
            action on the same.
          </li>

          <li style={{ lineHeight: "2" }}>
            <i class="fa fa-hand-o-right"></i>
            The Nodal Officer has a time of 15 days to resolve the Grievance
            from the date of receiving of Grievance. Details of Nodal Officer
            are mentioned below:
          </li>
        </ul>

        <p>Name:-Unify wellness</p>
        <p>Mobile Number:+91 88519 24626 </p>
        <p>Email ID: director@unifywellness.com</p>
        {/* <p>
          Address: 55,2nd floor, Lane 2 , westend marg ,saidullajab, near saket
          metro station,new delhi ,110030
        </p> */}
      </div>
      <Footer />
    </>
  );
}

export default GrievanceRedressal;
